module.exports = __webpack_public_path__ + "static/planktonsummit-679498a966943d2a727e2ccb24fc507d.svg";